import React from 'react';

interface IconListProps {
  data: {
    items?: Array<{ icon: string; text: string }>;
    iconColor?: string;
    layout?: 'vertical' | 'horizontal';
    iconSize?: 'small' | 'medium' | 'large';
    [key: string]: unknown;
  };
  styles?: string;
}

export const IconList: React.FC<IconListProps> = ({ data, styles: _styles }) => {
  const { 
    items = [{ icon: '✓', text: 'Feature one' }, { icon: '✓', text: 'Feature two' }],
    iconColor = '#3b82f6',
    layout = 'vertical',
    iconSize = 'medium'
  } = data ?? {};

  const sizeClasses = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg'
  };

  return (
    <div className="">
      <ul className={`${layout === 'horizontal' ? 'flex flex-wrap gap-4' : 'space-y-2'}`}>
        {items.map((item, i) => (
          <li key={i} className={`flex items-center gap-2 ${sizeClasses[iconSize]}`}>
            <span style={{ color: iconColor }}>{item.icon}</span>
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
